import { Order, RestApiConfig } from "@smeetz/orders";
import { OrderDataProvider } from "./order-data-provider";
import { LogLevel, LogService } from "@/services/logging";

/**
 * Initializes the Order service with a dynamic configuration.
 * This setup allows the API client to use the correct authentication token.
 * Never throws — it runs synchronously inside appSetup, and a throw would
 * abort the whole bootstrap. On failure the root cause is journaled here and
 * later order operations fail loudly with the orders package's own
 * "DataProvider not initialized" error.
 */
export function initializeOrderService(): void {
  try {
    const apiUrl = import.meta.env.VITE_SERVICES_API as string;
    if (!apiUrl) {
      throw new Error("VITE_SERVICES_API is not set");
    }

    const config: RestApiConfig = {
      apiUrl,
      version: "v1",
      timeout: 30000,
      retries: 3,
      headers: {
        "X-Custom-Header": "smeetz-pos-v1.0",
      },
    };

    const orderDataProvider = new OrderDataProvider(config);
    Order.initDataProvider(orderDataProvider);
  } catch (error) {
    // Swallowed on purpose (bootstrap must survive); console.error keeps dev
    // visibility while LogService ships it.
    console.error("OrderService initialization failed:", error);
    LogService.info(
      "OrderService initialization failed",
      { error },
      LogLevel.Error
    );
  }
}
